<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <ng-content></ng-content>
</mat-dialog-content>
<mat-dialog-actions class="tds-u-flex tds-u-gap2">
  @if (!hideDefaultActions) {
    @if (onlyClose) {
      <tds-button
        (click)="cancel()"
        size="lg"
        text="Fechar"
        variant="secondary"
        title="Fechar"
      ></tds-button>
    } @else {
      @if (isLoading) {
        <app-spinner [overlay]="false" size="md"></app-spinner>
      } @else {
        <tds-button
          (click)="onSave()"
          size="lg"
          text="{{ saveMessage }}"
          variant="primary"
          title="Save"
        >
        </tds-button>
        <tds-button
          (click)="cancel()"
          size="lg"
          text="Fechar"
          variant="secondary"
          title="Close"
        ></tds-button>
      }
    }
  }
</mat-dialog-actions>
